/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { isBrowser } from "react-device-detect";
import { getCities, getNeighborhoods, getStates } from "requests/Address";
import { getAll } from "requests/FindDoctor";
import { getNameProvider, getProvidersType } from "requests/Providers";
import { getSpecialist } from "requests/Specialist";
import { IFilters, IFindDoctor, ILabelValue } from "shared/types";

interface IProps {
  children: any;
}

export interface IMetrusContext {
  step: number;
  setStep: (step: number) => void;
  setList: (list: boolean) => void;
  list: boolean;
  insuranceIdNext: number;
  setInsuranceIdNext: (insuranceIdNext: number) => void;
  descList: boolean;
  setDescList: (descList: boolean) => void;
  providerId: string;
  setProviderId: (value: string) => void;
  specialistId: string;
  setSpecialistId: (value: string) => void;
  loading: boolean;
  setLoading: (value: boolean) => void;
  service: IFindDoctor[];
  setService: (value: IFindDoctor[]) => void;
  page: number;
  setPage: (value: number) => void;
  totalPages: number;
  setTotalPages: (value: number) => void;
  disabledCity: boolean;
  setDisabledCity: (value: boolean) => void;
  specialistSelect: ILabelValue[];
  setSpecialistSelect: (value: ILabelValue[]) => void;
  typeSelect: ILabelValue[];
  setTypeSelect: (value: ILabelValue[]) => void;
  cityId: string;
  setCityId: (value: string) => void;
  regionName: string;
  setRegionName: (value: string) => void;
  neighID: string;
  setNeighId: (value: string) => void;
  state: string;
  setState: (value: string) => void;
  nameProviderId: string;
  setNameProviderId: (value: string) => void;
  states: ILabelValue[];
  cities: ILabelValue[];
  neighborhood: ILabelValue[];
  nameProvider: ILabelValue[];
  emergency: boolean;
  setEmergency: (value: boolean) => void;
  disabledNeigh: boolean;
  setDisabledNeigh: (value: boolean) => void;
  disabledStreet: boolean;
  setDisabledStreet: (value: boolean) => void;
  disabledName: boolean;
  setDisabledName: (value: boolean) => void;
  setDisabledRegion: (value: boolean) => void;
  disabledRegion: boolean;
  region: ILabelValue[];
  setRegion: (value: ILabelValue[]) => void;
  lat: number;
  long: number;
  isWebView: boolean;
  latGoogle: number;
  setLatGoogle: (n: number) => void;
  longGoogle: number;
  setLongGoogle: (n: number) => void;
  preferr: "TYPE" | "NOT_DEFINED" | "SELECT";
  setPreferr: (value: "TYPE" | "NOT_DEFINED" | "SELECT") => void;
  planShow: string;
  setPlanShow: (value: string) => void;
  filters: any;
  setFilters: (value: any) => void;
}

interface GeolocationOptions {
  enableHighAccuracy: boolean;
  timeout: number;
  maximumAge: number;
}

interface Position {
  coords: {
    latitude: number;
    longitude: number;
  };
}

interface PositionError {
  code: number;
  message: string;
}

const MetrusContext = React.createContext({} as IMetrusContext);

const MetrusProvider: React.FC<IProps> = ({ children }) => {
  const [step, setStep] = React.useState<number>(1);
  const [list, setList] = React.useState<boolean>(false);
  const [insuranceIdNext, setInsuranceIdNext] = React.useState<number>(0);
  const [descList, setDescList] = React.useState<boolean>(false);
  const [providerId, setProviderId] = React.useState<string>("");
  const [specialistId, setSpecialistId] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [service, setService] = React.useState<IFindDoctor[]>([]);
  const [page, setPage] = React.useState<number>(1);
  const [totalPages, setTotalPages] = React.useState<number>(0);
  const [disabledCity, setDisabledCity] = React.useState<boolean>(true);

  const [specialistSelect, setSpecialistSelect] = React.useState<ILabelValue[]>(
    [],
  );

  const [typeSelect, setTypeSelect] = React.useState<ILabelValue[]>([]);

  const [cityId, setCityId] = React.useState<string>("");

  const [regionName, setRegionName] = React.useState<string>("");
  const [neighID, setNeighId] = React.useState<string>("");
  const [state, setState] = React.useState<string>("");
  const [nameProviderId, setNameProviderId] = React.useState<string>("");

  const [states, setStates] = React.useState<ILabelValue[]>([]);
  const [cities, setCities] = React.useState<ILabelValue[]>([]);
  const [neighborhood, setNeighbordhood] = React.useState<ILabelValue[]>([]);
  const [nameProvider, setNameProvider] = React.useState<ILabelValue[]>([]);
  const [region, setRegion] = React.useState<ILabelValue[]>([]);

  const [emergency, setEmergency] = React.useState<boolean>(false);

  const [disabledRegion, setDisabledRegion] = React.useState<boolean>(true);
  const [disabledNeigh, setDisabledNeigh] = React.useState<boolean>(true);
  const [disabledStreet, setDisabledStreet] = React.useState<boolean>(true);
  const [disabledName, setDisabledName] = React.useState<boolean>(true);

  const [lat, setLat] = React.useState<number>(0);
  const [long, setLong] = React.useState<number>(0);
  const [isWebView, setIsWebView] = React.useState<boolean>(false);
  const [latGoogle, setLatGoogle] = React.useState<number>(0);
  const [longGoogle, setLongGoogle] = React.useState<number>(0);

  const [planShow, setPlanShow] = React.useState<string>("");

  const [preferr, setPreferr] = React.useState<
    "TYPE" | "NOT_DEFINED" | "SELECT"
  >("NOT_DEFINED");

  const [filters, setFilters] = React.useState<IFilters>({
    sortAlpha: "az",
    networkFilter: "1",
  } as IFilters);
  const handleStates = React.useCallback(async () => {
    const { status, data } = await getStates(insuranceIdNext);

    if ([200, 201].includes(status)) {
      const values: ILabelValue[] = [];

      data.forEach((state) =>
        values.push({ label: state.END_ESTADO, value: state.END_ESTADO }),
      );
      setStates(values);
    }
  }, [insuranceIdNext]);

  const handleCities = React.useCallback(async () => {
    const { status, data } = await getCities(state, insuranceIdNext);

    if ([200, 201].includes(status)) {
      const saoPauloCities: ILabelValue[] = [];
      const otherCities: ILabelValue[] = [];
      const restRegion: ILabelValue[] = [];
      const allRegion: ILabelValue[] = [];

      let hasSaoPauloCity = false;

      data.forEach((city) => {
        if (city.END_CIDADE === "São Paulo" && city.END_REGIAO === null) {
          hasSaoPauloCity = true;
          saoPauloCities.push({
            label: `${city.END_CIDADE}`,
            value: `${city.END_CIDADE}`,
          });
        }
        if (city.END_CIDADE !== "São Paulo") {
          otherCities.push({
            label: `${city.END_CIDADE}`,
            value: `${city.END_CIDADE}`,
          });
        }
        if (city.END_REGIAO !== null) {
          restRegion.push({
            label: `${city.END_REGIAO}`,
            value: `${city.END_REGIAO}`,
          });
        }
      });

      if (!hasSaoPauloCity) {
        saoPauloCities.push({
          label: "São Paulo",
          value: "São Paulo",
        });
      }

      allRegion.push({
        label: "Todos",
        value: "",
      });

      const values = [...saoPauloCities, ...otherCities];
      const valuesRegion = [...allRegion, ...restRegion];
      setCities(values);
      setRegion(valuesRegion);

      setDisabledCity(false);
    }
  }, [state]);

  const handleNeighborhood = React.useCallback(async () => {
    const { status, data } = await getNeighborhoods(
      state,
      cityId,
      insuranceIdNext,
      regionName,
    );

    if ([200, 201].includes(status)) {
      const valuesNeigh: ILabelValue[] = [];
      const valuesAll: ILabelValue[] = [];

      data.forEach((city) =>
        valuesNeigh.push({ label: city.END_BAIRRO, value: city.END_BAIRRO }),
      );

      valuesAll.push({
        label: "Todos",
        value: "",
      });

      const values = [...valuesAll, ...valuesNeigh];
      setNeighbordhood(values);
    }
  }, [cityId, regionName]);

  const handleSpecialist = React.useCallback(async () => {
    const { status, data } = await getSpecialist(
      state,
      insuranceIdNext,
      cityId,
      neighID,
      providerId,
      regionName,
    );

    if ([200, 201].includes(status)) {
      const values: ILabelValue[] = [];

      data.forEach((state) =>
        values.push({ label: state.ESP_NOME, value: state.ESP_ID }),
      );
      setSpecialistSelect(values);
    }
  }, [insuranceIdNext, state, cityId, regionName, neighID, providerId]);

  const handleNameProvider = React.useCallback(async () => {
    const { status, data } = await getNameProvider(
      state,
      insuranceIdNext,
      cityId,
      neighID,
      specialistId,
      providerId,
      regionName,
    );

    if ([200, 201].includes(status)) {
      const values: ILabelValue[] = [];

      if (data.length > 0) {
        setDisabledName(false);
      }

      if (data.length === 0) {
        setDisabledName(true);

        return false;
      }

      data.forEach((state) =>
        values.push({ label: state.PRE_FANTASIA, value: state.PRE_ID }),
      );
      setNameProvider(values);
    }
  }, [
    cityId,
    neighID,
    state,
    insuranceIdNext,
    specialistId,
    providerId,
    regionName,
  ]);

  const handleTypeProvider = React.useCallback(async () => {
    const { status, data } = await getProvidersType(
      state,
      insuranceIdNext,
      cityId,
      neighID,
      regionName,
    );

    if ([200, 201].includes(status)) {
      const values: ILabelValue[] = [];

      data.forEach((state) =>
        values.push({ label: state.TIP_NOME, value: state.TIP_ID }),
      );
      setTypeSelect(values);
    }
  }, [insuranceIdNext, state, cityId, regionName, neighID, specialistId]);

  React.useEffect(() => {
    handleStates();
  }, [handleStates]);

  React.useEffect(() => {
    handleCities();
  }, [handleCities]);

  React.useEffect(() => {
    handleNeighborhood();
  }, [handleNeighborhood]);

  React.useEffect(() => {
    handleSpecialist();
  }, [handleSpecialist]);

  React.useEffect(() => {
    handleNameProvider();
  }, [handleNameProvider]);

  React.useEffect(() => {
    handleTypeProvider();
  }, [handleTypeProvider]);

  const handleAll = React.useCallback(async () => {
    try {
      setLoading(true);
      const { status, data } = await getAll(filters);

      if ([200, 201].includes(status)) {
        setService(data.results ?? []);
        setTotalPages(data.size);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  }, [filters]);

  React.useEffect(() => {
    console.log("---FILTERS ----");
    console.log(filters);
  }, [filters]);

  React.useEffect(() => {
    handleAll();
  }, [handleAll]);

  React.useEffect(() => {
    const userAgent = navigator.userAgent;

    // Heurísticas básicas para detecção de WebView
    const webViewPatterns = [
      // Padrões comuns de user-agent para Android WebView
      "wv",
      "Version/",
      // Padrões específicos de WebView para iOS (podem incluir palavras como WebView)
      "(iPhone|iPod|iPad)(?=.*AppleWebKit)",
    ];

    const regex = new RegExp(webViewPatterns.join("|"), "i");
    setIsWebView(!isBrowser && regex.test(userAgent));
  }, []);

  const sucesso = (posicao: Position): void => {
    const { latitude, longitude } = posicao.coords;
    localStorage.setItem(
      "positionUser",
      JSON.stringify({ lat: latitude, long: longitude }),
    );

    setLat(latitude);
    setLong(longitude);
  };

  const erro = (erro: PositionError): void => {
    console.warn(`Erro (${erro.code}): ${erro.message}`);
  };

  const opcoes: GeolocationOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(sucesso, erro, opcoes);
  } else {
    console.log("Geolocalização não é suportada por este navegador.");
  }

  React.useEffect(() => {
    localStorage.clear();
  }, []);

  const value = React.useMemo(
    () => ({
      step,
      setStep,
      list,
      setList,
      insuranceIdNext,
      setInsuranceIdNext,
      descList,
      setDescList,
      providerId,
      setProviderId,
      specialistId,
      setSpecialistId,
      loading,
      setLoading,
      service,
      setService,
      page,
      setPage,
      totalPages,
      setTotalPages,
      disabledCity,
      setDisabledCity,
      specialistSelect,
      setSpecialistSelect,
      typeSelect,
      setTypeSelect,
      cityId,
      setCityId,
      regionName,
      setRegionName,
      neighID,
      setNeighId,
      state,
      setState,
      nameProviderId,
      setNameProviderId,
      states,
      cities,
      neighborhood,
      nameProvider,
      emergency,
      setEmergency,
      disabledRegion,
      setDisabledRegion,
      disabledNeigh,
      setDisabledNeigh,
      disabledStreet,
      setDisabledStreet,
      disabledName,
      setDisabledName,
      region,
      setRegion,
      lat,
      long,
      isWebView,
      latGoogle,
      setLatGoogle,
      longGoogle,
      setLongGoogle,
      preferr,
      setPreferr,
      planShow,
      setPlanShow,
      filters,
      setFilters,
    }),
    [
      step,
      setStep,
      list,
      setList,
      insuranceIdNext,
      setInsuranceIdNext,
      descList,
      setDescList,
      providerId,
      setProviderId,
      specialistId,
      setSpecialistId,
      loading,
      setLoading,
      service,
      setService,
      page,
      setPage,
      totalPages,
      setTotalPages,
      disabledCity,
      setDisabledCity,
      specialistSelect,
      setSpecialistSelect,
      typeSelect,
      setTypeSelect,
      cityId,
      setCityId,
      regionName,
      setRegionName,
      neighID,
      setNeighId,
      state,
      setState,
      nameProviderId,
      setNameProviderId,
      states,
      cities,
      neighborhood,
      nameProvider,
      emergency,
      setEmergency,
      disabledRegion,
      setDisabledRegion,
      disabledNeigh,
      setDisabledNeigh,
      disabledStreet,
      setDisabledStreet,
      disabledName,
      setDisabledName,
      region,
      setRegion,
      lat,
      long,
      isWebView,
      latGoogle,
      setLatGoogle,
      longGoogle,
      setLongGoogle,
      preferr,
      setPreferr,
      planShow,
      setPlanShow,
      filters,
      setFilters,
    ],
  );

  return (
    <MetrusContext.Provider value={value}>{children}</MetrusContext.Provider>
  );
};

const useMetrus = (): IMetrusContext => React.useContext(MetrusContext);

export { MetrusContext, MetrusProvider, useMetrus };
